import { boolean, dateTime, defineAction, enumerated, object, string } from '~/prix'
import entrepreneurAgentCloseRequest from './entrepreneurAgentCloseRequest.action.json' with { type: 'json' }

const entrepreneurAgentCloseRequestDefinition = defineAction({
  ...entrepreneurAgentCloseRequest,
  userActivityLog: true,
  operation: 'update' as const,
  input: object({
    entrepreneurCpf: string(),
    reason: enumerated({
      done: 'done',
      canceled: 'canceled',
    }),
    cancellationReason: string().isOptional(),
    cancellationReasonDetails: string().isOptional(),
  }),
  output: object({
    success: boolean(),
    state: enumerated({
      done: 'done',
      canceled: 'canceled',
    }).isOptional(),
    closedAt: dateTime().isOptional(),
    message: string().isOptional(),
  }),
})

export default entrepreneurAgentCloseRequestDefinition
